import classNames from 'classnames';
import PropTypes from 'prop-types';
// import React, { useMemo } from 'react';
import React from 'react';
// import ReactModal from 'react-modal';
import CustomModal from '../../containers/custom-modal';

import { Box } from "@chakra-ui/layout";
import Button from '../../button/button.jsx';

import closeIcon from './icon-close.png';
import symbolLogo from './symbolLogo.png';

import './wrapModalComponent.css';
import {getMobileOS} from '../../lib/supported-browser';

// 登录框内部的模态
const WrapModalComponent = props => {
    // 模态左上角的logo
    // const ModalLogo = useMemo(() => (
    //     <div className={styles.modalLogoContainer}>
    //         <img
    //             src={symbolLogo}
    //             className={styles.modalLogo}
    //         />
    //     </div>
    // ), []);
    return (
        // <ReactModal
        //     isOpen
        //     className={classNames(getMobileOS() === 'PC' ? styles.modalContentPC : styles.modalContent, props.className)}
        //     overlayClassName={styles.modalOverlay}
        //     onRequestClose={props.onRequestClose}
        // >
        <CustomModal
            className={
                getMobileOS() === 'PC' ? 
                `modalContentPC ${props.className}` : 
                `modalContent ${props.className}`
            }
            id="loginModal"
            // className={`getMobileOS() === 'PC' ? "modalContentPC ${props.className}" : "modalContent ${props.className}"`}
            contentLabel={props.contentLabel}
            hasHeaderLine={false}
            headerImageTop={props.headerImageTop}
            onRequestClose={props.onRequestClose}
        >
            <Box
                dir={props.isRtl ? 'rtl' : 'ltr'}
                direction="column"
                grow={1}
            >
                {props.children}
            </Box>
        </CustomModal>
    );
};

WrapModalComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    contentLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    headerClassName: PropTypes.string,
    isRtl: PropTypes.bool,
    onRequestClose: PropTypes.func
};

export default WrapModalComponent;
